import React from "react";
import { footerLinks } from "../data/page";
export function SiteFooter() {
  return <footer className="bg-navy-950 px-4 pb-32 pt-12 text-white sm:px-6" data-id="element-307" data-mp="3r8j26ssbaukj">
      <div className="mx-auto max-w-5xl text-center" data-id="element-308" data-mp="3raltdg57atqu">
        <p className="font-display text-2xl font-bold uppercase" data-id="element-309" data-mp="3mghnl07o8rrc">Diabetic Foot Assessment Blueprint™</p>
        <p className="mt-1 text-white/70" data-id="element-310" data-mp="3hhojtzi6sf4d">An educational reference by Dr. Ryan Carter</p>

        <nav aria-label="Legal" className="mt-6" data-id="element-311" data-mp="3dhw492udl8pi">
          <ul className="flex flex-col items-center gap-3 sm:flex-row sm:flex-wrap sm:justify-center sm:gap-6" data-id="element-312" data-mp="3dei5e4kx7hmt">
            {footerLinks.map(l => <li key={l.label} data-id="element-313" data-mp="33jgeb37345hl">
                <a href={l.href} className="text-sm text-white/80 underline-offset-4 transition-colors duration-150 ease-out hover:text-white hover:underline" data-id="element-314" data-mp="33krjn7g6hlat">
                  {l.label}
                </a>
              </li>)}
          </ul>
        </nav>

        <div className="mx-auto mt-8 max-w-3xl border-t border-white/10 pt-6 text-left sm:text-center" data-id="element-315" data-mp="15qvbp9wjd1jy">
          <p className="text-xs font-bold uppercase tracking-wide text-white/80" data-id="element-316" data-mp="1apop72btosk4">Educational disclaimer</p>
          <p className="mt-2 text-xs leading-relaxed text-white/60" data-id="element-317" data-mp="vt7ca6nzj5vg">
            This product is intended for educational purposes and does not replace professional education, clinical
            judgment, current evidence-based guidelines, or patient-specific assessment. Clinical decisions must be made
            by appropriately qualified professionals within their scope of practice and in accordance with applicable
            standards and local protocols.
          </p>
          <p className="mt-6 text-xs text-white/50" data-id="element-318" data-mp="1jqmsfiefsw1n">
            © 2026 DIABETIC FOOT ASSESSMENT BLUEPRINT™. All rights reserved.
          </p>
        </div>
      </div>
    </footer>;
}